<app-img-header-mobile
  title="Cotizador comercial"
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header-mobile>
@if(isLoading()){
<app-preloader></app-preloader>
}
<app-notifications></app-notifications>

<main class="main" id="">
  <div id="detail" class="white">
    <div class="pageWidth">
      <h3>Cotizaciones</h3>
      <div class="actionsWrapper">
        <button class="tertiary" [routerLink]="['/quote/open-quote/new-open-quote']">
          <i class="icon"></i> Nueva cotización
        </button>
      </div>
      @if(!hasData){
      <div class="noData">No hay información para mostrar</div>
      } @else{
      <div class="customListMobile listadoCotizacionesComercialesMobile">
        @for(quote of data; track getRowKey(quote.id, $index)){
        <div class="row">
          <div class="general">
            <div class="wrapper">
              <div class="numero">
                {{ quote.id }}
              </div>
              <div class="cliente">
                @if(quote?.customerName?.length > 17){
                <span> {{ quote?.customerName }} </span>
                } @else { {{ quote?.customerName }}
                }
              </div>
            </div>
            <div class="wrapper">
              <!-- Incluir clase "borrador", "enProgreso", "completo"-->
              <div class="tag" [ngClass]="getStatusClass(quote.status)">
                {{ getStatus(quote.status) }}
              </div>
              <!-- Incluir la clase "active" cuando se está mostrando el menú-->
              <div
                class="contextualMenuMobile"
                [ngClass]="{
                  active: isMenuRowOpen(getRowKey(quote.id, $index))
                }"
              >
                <a
                  class="toggle"
                  aria-haspopup="menu"
                  aria-controls="menu-id"
                  role="button"
                  [attr.aria-expanded]="!!openRowOption()"
                  [id]="getMobileMenuTriggerId(getRowKey(quote.id, $index))"
                  (click)="toggleMobileMenuOptions($event, getRowKey(quote.id, $index))"
                  >Ver/Ocultar menu</a
                >
                <div
                  class="menuContent"
                  role="menu"
                  id="menu-id"
                  appBackdropOverlay
                  appOutSideClick
                  [isActive]="!!openRowOption()"
                  [ignoreElements]="[getMobileMenuTriggerId(getRowKey(quote.id, $index))]"
                  [activeTarget]="openRowOption()"
                  [currentTarget]="getRowKey(quote.id, $index)"
                  (outSideClick)="closeMobileMenuOptions()"
                  style="z-index: 40"
                >
                  <ul>
                    @if(userId != quote.userId){
                    <li role="menuitem">
                      <a [routerLink]="['/quote/edit-quote-open/' + quote.id]" [queryParams]="{ view: 'readonly' }" class="iconAndText view">Ver</a>
                    </li>
                    } @else if (quoteIsTerminalCustomerOnly(quote)) {
                    <li role="menuitem">
                      <a [routerLink]="['/quote/edit-quote-open/' + quote.id]" [queryParams]="{ view: 'readonly' }" class="iconAndText view">Ver</a>
                    </li>
                    } @else if (quoteIsInReview(quote)) {
                    <li role="menuitem">
                      <a
                        [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                        [queryParams]="quote.linkedToCreditRequest === true ? { view: 'readonly' } : null"
                        class="iconAndText view"
                      >Ver</a>
                    </li>
                    } @else {
                    <li role="menuitem">
                      <a
                        [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                        [queryParams]="quote.linkedToCreditRequest === true ? { view: 'readonly' } : null"
                        class="iconAndText"
                        [ngClass]="{ edit: quote.linkedToCreditRequest !== true, view: quote.linkedToCreditRequest === true }"
                      >
                        {{ quote.linkedToCreditRequest === true ? 'Ver' : 'Editar' }}
                      </a>
                    </li>
                    }

                    <li role="menuitem">
                      <a class="iconAndText duplicate" (click)="openModalConfirmationToDuplicateOpenQuote(quote)"
                        >Duplicar</a
                      >
                    </li>
                    @if (canExtendOpenQuoteValidity(quote)) {
                    <li role="menuitem">
                      <a class="iconAndText edit" (click)="extendOpenQuoteValidity(quote, $event)">Extender vigencia</a>
                    </li>
                    }
                    @if(userId == quote.userId && !quoteBlocksEditAndDelete(quote) && quote.linkedToCreditRequest !== true){
                    <li role="menuitem">
                      <a (click)="openModalConfirmation(quote)" class="iconAndText delete">Eliminar</a>
                    </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="title">
            <div class="cotizacion">
              <span>
                {{ quote.quoteName }}
              </span>
            </div>
            <div class="propuestas">
              {{ quote.dealAmount }}
              <span>Propuesta<span *ngIf="quote.dealAmount > 1">s</span></span>
            </div>
          </div>
          <div class="data">
            <div class="fa">
              <span>Total FA</span>
              <b>{{ formatInputValue(quote.faTotal) }}</b>
            </div>
            <div class="rorac" *ngIf="quote.roRac">
              <span>RoRAC</span>
              <b>{{ quote.roRac ? quote.roRac : '' }} <span>%</span></b>
            </div>
            <div class="propietario">
              @if(quote.userName && quote.userName?.length > 21){
              <span>
                {{ quote.userName }}
              </span>
              } @else {
              <span>Propietario</span>
              {{ quote.userName }}
              }
            </div>
            <div class="edicion">
              <span>Última edición</span>
              {{ format(quote.updatedDate, true) }}
            </div>
          </div>
        </div>
        }
      </div>
      }
      <!-- Oculta temporalmente el paginador -->
      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>

      <div class="actionsWrapper">
        <button class="tertiary" [routerLink]="['/quote/open-quote/new-open-quote']">
          <i class="icon"></i> Nueva cotización
        </button>
      </div>
    </div>
  </div>
</main>

<!-- Filtros -->
<ng-template #template>
  <div class="wrapperG4">
    <div>
      <label>Estado</label>
      <app-select
        [options]="status.data"
        [placeholder]="status.placeholder"
        (optionSelected)="filter($event, status.filterType)"
        [resetSelect]="reset"
      ></app-select>
    </div>
    <div>
      <label>Nombre de la cotización</label>
      <app-input
        [data]="searchNameQuote"
        (textSearch)="filter($event, 'quoteName')"
        [showIcon]="false"
        [resetInput]="reset"
      ></app-input>
    </div>
    <div>
      <label>Nombre del cliente</label>
      @if(isActiveClientCatalog){
      <app-input-api-search
        [endpoint]="getAllClientsUrl()"
        httpMethod="POST"
        searchKey="customerName"
        labelKey="customerName"
        placeholder="Buscar cliente"
        [additionalParams]="readonlyAdditionalSearchClientParams"
        (searchSelected)="handleSearchClient($event)"
        (textChange)="handleTextChange($event)"
        [resetInput]="reset"
        [disableNotFound]="true"
      ></app-input-api-search>
      } @else {
      <app-input
        [data]="searchNameCustomer"
        (textSearch)="filter($event, 'customerName')"
        [showIcon]="false"
        [resetInput]="reset"
      ></app-input>
      }
    </div>

    <div>
      <label>Propietario</label>
      <app-select
        [options]="owners"
        [placeholder]="'Seleccione un propietario'"
        (optionSelected)="filter($event, 'userId')"
        [resetSelect]="reset"
      ></app-select>
    </div>
    @if(isActiveClientCatalog){
    <div>
      <label>Tipo de cliente</label>
      <app-select
        [options]="customerTypeList"
        [placeholder]="'Buscar por registro RFC'"
        [defaultValue]="params.filter.isExternalCustomer"
        (optionSelected)="filter($event, 'isExternalCustomer')"
        [resetSelect]="reset"
      ></app-select>
    </div>
    } @if(isActiveClientCatalog){
    <div>
      <app-date-picker
        [isRange]="true"
        label="Fecha de creación"
        placeholderFrom="Desde"
        placeholderTo="Hasta"
        [selectedDateFrom]="params.filter.from"
        [selectedDateTo]="params.filter.to"
        (selectedDateFromChange)="filter($event, 'from')"
        (selectedDateToChange)="filter($event, 'to')"
      ></app-date-picker>
    </div>
    } @else {
    <div>
      <app-date-picker
        [isRange]="true"
        label="Fecha de creación"
        placeholderFrom="Desde"
        placeholderTo="Hasta"
        [selectedDateFrom]="params.filter.from"
        [selectedDateTo]="params.filter.to"
        (selectedDateFromChange)="filter($event, 'from')"
        (selectedDateToChange)="filter($event, 'to')"
      ></app-date-picker>
    </div>
    }

    <div>
      <label class="checkboxWrapper myQuotation" for="myQuotation">
        <input type="checkbox" id="myQuotation" [(ngModel)]="params.filter.me" (ngModelChange)="filter($event, 'me')" />
        <span class="checkmark"></span>
        <span class="description">Mis cotizaciones</span>
      </label>
    </div>
  </div>

  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
  </div>
</ng-template>
<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deleteQuoteById()"
  ></app-template-confirmation>
</ng-template>
<ng-template #templateDuplicateQuote>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="duplicateQuoteById()"
  ></app-template-confirmation>
</ng-template>
